import { axiosInstance as request } from '@api/rest.service'

/**
 * @description GET /vendors?paginated=true (+ag grid filter model)
 * @returns {AxiosPromise<any>}
 */
export const GET_PAGINATED_VENDORS = params => request.get('/vendors?paginated=true', { params })

/**
 * @description GET /vendors
 * @returns {AxiosPromise<any>}
 */
export const GET_VENDORS = () => request.get('/vendors')

/**
 * @description GET /vendors/create
 * @returns {AxiosPromise<any>}
 */
export const GET_VENDORS_CREATE = () => request.get('/vendors/create')

/**
 * @description POST /vendors
 * @returns {AxiosPromise<any>}
 */
export const CREATE_VENDOR = payload => request.post('/vendors', payload)

/**
 * @description GET /vendors/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_VENDOR = id => request.get(`/vendors/${id}?include=addresses`)

/**
 * @description PATCH /vendors/{id}
 * @returns {AxiosPromise<any>}
 */
export const MODIFY_VENDOR = (id, payload) => request.patch(`/vendors/${id}`, payload)

/**
 * @description DELETE /vendors/{id}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_VENDOR = id => request.delete(`/vendors/${id}`)

/**
 * @description GET /vendors/{id}/delete-confirmation
 * @returns {AxiosPromise<any>}
 */
export const GET_VENDOR_DELETE_CONFIRMATION = id => request.get(`/vendors/${id}/delete-confirmation`)

/**
 * @description GET /vendors/{id}/subscriptions?paginated=true (+ag grid filter model)
 * @returns {AxiosPromise<any>}
 */
export const GET_PAGINATED_VENDOR_SUBSCRIPTIONS = (id, params) =>
  request.get(`/vendors/${id}/subscriptions?paginated=true`, { params })

/**
 * @description GET /vendors/{id}/orders
 * @returns {AxiosPromise<any>}
 */
export const GET_VENDOR_ORDERS = id => request.get(`/vendors/${id}/orders`)

/**
 * @description GET /vendors/{id}/invoices
 * @returns {AxiosPromise<any>}
 */
export const GET_INVOICES_OF_VENDOR = id => request.get(`/vendors/${id}/invoices`)

/**
 * @description GET /vendors/{id}/contacts
 * @returns {AxiosPromise<any>}
 */
export const GET_VENDOR_CONTACTS = id => request.get(`/vendors/${id}/contacts`)
